import { REGRAS_SENHA } from "../../utils/forcaSenha";

// Feedback ao vivo enquanto digita a nova senha — usado em TrocarSenhaCard e
// na tela de redefinir senha (link por email).
export default function ChecklistSenha({ senha }: { senha: string }) {
  return (
    <ul className="mt-1.5 space-y-0.5 text-xs">
      {REGRAS_SENHA.map((r) => {
        const ok = r.testar(senha);
        return (
          <li key={r.label} className={ok ? "text-success-600 dark:text-success-500" : "text-gray-500 dark:text-gray-400"}>
            {ok ? "✓" : "○"} {r.label}
          </li>
        );
      })}
    </ul>
  );
}
